import React, { useEffect, useState } from 'react'
import FiltroVacacionesSolicitadas from './FiltroVacacionesSolicitadas'
import ListaVacacionesSolicitadas from './ListaVacacionesSolicitadas'
import { ApiSolicitudVacacionesService } from 'services/ApiSolicitudVacacionesService';
import { useAuth } from 'context/AuthProvider';

const MostrarVacacionesSolicitadas = () => {
    const {empleado} = useAuth()
    const [estado, setEstado] = useState("PENDIENTE");
    const [desde, setDesde] = useState("");
    const [hasta, setHasta] = useState("");
    const [descripcion, setDescripcion] = useState("");

    const [datos, setDatos] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            //TODO: aplicar filtro
            
            const response = await ApiSolicitudVacacionesService.getSolicitadasByEmpleadoId(empleado.id,desde,hasta,estado);
            response.json().then(data => setDatos(data));
        }


        fetchData();
    }, [estado, desde, hasta,descripcion, empleado.id])


    return (
        <>
            <FiltroVacacionesSolicitadas
                setEstado={setEstado}
                setDesde={setDesde}
                setHasta={setHasta} 
                 setDescripcion={setDescripcion} />
            <ListaVacacionesSolicitadas
                datos={datos} />
        </>
    )
}

export default MostrarVacacionesSolicitadas 